import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { EmailStore } from 'src/app/shared/services/email/email.state';

export const clearEmailStore: CanDeactivateFn<void> = () => {
  const emailStore = inject(EmailStore);
  emailStore.reset();
  return true;
};
